import { render, staticRenderFns } from "./MissionNotificationCardContent.vue?vue&type=template&id=274f3dc0&scoped=true&"
import script from "./MissionNotificationCardContent.vue?vue&type=script&lang=js&"
export * from "./MissionNotificationCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f3dc0",
  null
  
)

export default component.exports